import { PlusIcon } from "@heroicons/react/20/solid";
import PrimaryButton from "./PrimaryButton";

const EmptyState = ({ text, subText, buttonText, onClick, disabled = false }) => {
  return (
    <div className="text-center py-8">
      <svg
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="mx-auto size-10 text-ink-300"
      >
        <path
          d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          strokeWidth={1.5}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3 className="mt-4 font-display text-xl text-ink-900">{text}</h3>
      {subText && <p className="mt-1 text-sm text-ink-500">{subText}</p>}
      {buttonText && onClick && (
        <div className="mt-6">
          <PrimaryButton
            onClick={onClick}
            colour="blue"
            className="inline-flex items-center"
            disabled={disabled}
          >
            <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5" />
            {buttonText}
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
